import { router } from "@inertiajs/react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { reportsPath } from "@/routes"

const REPORT_REASONS = [
  { value: "spam", label: "Spam" },
  { value: "inappropriate", label: "Contenido inapropiado" },
  { value: "harassment", label: "Acoso" },
  { value: "fake", label: "Informacion falsa" },
  { value: "scam", label: "Estafa" },
  { value: "dangerous", label: "Contenido peligroso" },
  { value: "other", label: "Otro" },
] as const

interface ReportDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  contentType: string
  contentId: number
}

export function ReportDialog({
  open,
  onOpenChange,
  contentType,
  contentId,
}: ReportDialogProps) {
  const [reason, setReason] = useState("")
  const [description, setDescription] = useState("")
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = () => {
    if (!reason) return

    setSubmitting(true)
    router.post(
      reportsPath(),
      {
        reported_type: contentType,
        reported_id: contentId,
        reason,
        description,
      },
      {
        preserveScroll: true,
        onFinish: () => {
          setSubmitting(false)
          setReason("")
          setDescription("")
          onOpenChange(false)
        },
      },
    )
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Reportar contenido</DialogTitle>
          <DialogDescription>
            Selecciona el motivo del reporte. Nuestro equipo lo revisara.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>Motivo</Label>
            <div className="space-y-1">
              {REPORT_REASONS.map((r) => (
                <label
                  key={r.value}
                  className="hover:bg-muted/50 flex cursor-pointer items-center gap-3 rounded-md px-3 py-2 transition-colors"
                >
                  <input
                    type="radio"
                    name="reason"
                    value={r.value}
                    checked={reason === r.value}
                    onChange={(e) => setReason(e.target.value)}
                    className="accent-primary"
                  />
                  <span className="text-sm">{r.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="report-description">
              Descripcion adicional (opcional)
            </Label>
            <Textarea
              id="report-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Agrega mas detalles sobre el reporte..."
              rows={3}
            />
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={submitting}
          >
            Cancelar
          </Button>
          <Button onClick={handleSubmit} disabled={!reason || submitting}>
            {submitting ? "Enviando..." : "Enviar reporte"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
